import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-group-item',
  templateUrl: './list-group-item.component.html',
  styleUrls: ['./list-group-item.component.scss']
})
export class ListGroupItemComponent implements OnInit {

  @Input() id: string;
  @Input() title: string;
  @Input() description: string = null;
  @Input() classes: string = null;
  @Input() isActive = false;

  isAPlace = false;

  constructor() { }

  ngOnInit() {
    if (this.classes === 'list-group-place') {
      this.isAPlace = true;
    }
  }
}
